exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#login{background-color:\"#f1f1f1\"}h1,h2{font-weight:400}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#35495e}", "", {"version":3,"sources":["C:/Users/chris/projetos/prepago/src/components/ResetSenha.vue"],"names":[],"mappings":"AACA,OACE,0BAA4B,CAC7B,AACD,MAEE,eAAoB,CACrB,AACD,GACE,qBAAsB,AACtB,SAAW,CACZ,AACD,GACE,qBAAsB,AACtB,aAAe,CAChB,AACD,EACE,aAAe,CAChB","file":"ResetSenha.vue","sourcesContent":["\n#login {\r\n  background-color: \"#F1F1F1\";\n}\nh1,\r\nh2 {\r\n  font-weight: normal;\n}\nul {\r\n  list-style-type: none;\r\n  padding: 0;\n}\nli {\r\n  display: inline-block;\r\n  margin: 0 10px;\n}\na {\r\n  color: #35495e;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71ae3f05","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ResetSenha.vue
// module id = 659
// module chunks = 1